<template>
  <div class="App-textfield mdl-textfield">
    <label
      class="mdl-textfield__label perm-label"
      for="textfield">{{label}}</label>
    <div class="App-textfield__input" v-html="formatSemicolonLinebreak" />
  </div>
</template>

<script>
export default {
  name: 'mdlDisplayfield',
  props: {
    fieldId: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    bvalue: {
      type: [String, Number]
    },
    type: {
      type: String
    }
  },
  computed: {
    // Default field type to text unless otherwise specified
    inputType() {
      return this.type ? this.type : 'text';
    },
    // Semicolons will break the line for display purposes
    formatSemicolonLinebreak() {
      return this.bvalue.replace(/;/g, '<br>');
    }
  },
  mounted() {
    this.$nextTick(() => {
      componentHandler.upgradeAllRegistered();
    });
  }
};
</script>

<style scoped>
.mdl-textfield {
  width: 100%;
}
.App-textfield {
  display: block;
  padding-right: 20px;
}
.App-textfield__input {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.12);
  margin-top: 8px;
  cursor: not-allowed;
}
.perm-label {
  color: rgb(63, 81, 181);
  font-size: 12px;
  top: 4px;
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/mdlDisplayfield.vue